/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputWeatherIngest
 */
export interface OutputWeatherIngest {
    /**
     * Enabled — чи зареєстровано крон збору (ENABLE_WIND_INGEST). Коли вимкнено, решта полів
     * описує лише останній прогін до вимкнення: нових оновлень не буде, NextRunAt порожній.
     * @type {boolean}
     * @memberof OutputWeatherIngest
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherIngest
     */
    intervalHours?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherIngest
     */
    lastDurationSec?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputWeatherIngest
     */
    lastError?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputWeatherIngest
     */
    lastFinishedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherIngest
     */
    lastRequests?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherIngest
     */
    lastSamples?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputWeatherIngest
     */
    lastStartedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputWeatherIngest
     */
    lastStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputWeatherIngest
     */
    nextRunAt?: string;
}

/**
 * Check if a given object implements the OutputWeatherIngest interface.
 */
export function instanceOfOutputWeatherIngest(value: object): boolean {
    return true;
}

export function OutputWeatherIngestFromJSON(json: any): OutputWeatherIngest {
    return OutputWeatherIngestFromJSONTyped(json, false);
}

export function OutputWeatherIngestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputWeatherIngest {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'intervalHours': json['intervalHours'] == null ? undefined : json['intervalHours'],
        'lastDurationSec': json['lastDurationSec'] == null ? undefined : json['lastDurationSec'],
        'lastError': json['lastError'] == null ? undefined : json['lastError'],
        'lastFinishedAt': json['lastFinishedAt'] == null ? undefined : json['lastFinishedAt'],
        'lastRequests': json['lastRequests'] == null ? undefined : json['lastRequests'],
        'lastSamples': json['lastSamples'] == null ? undefined : json['lastSamples'],
        'lastStartedAt': json['lastStartedAt'] == null ? undefined : json['lastStartedAt'],
        'lastStatus': json['lastStatus'] == null ? undefined : json['lastStatus'],
        'nextRunAt': json['nextRunAt'] == null ? undefined : json['nextRunAt'],
    };
}

export function OutputWeatherIngestToJSON(value?: OutputWeatherIngest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'enabled': value['enabled'],
        'intervalHours': value['intervalHours'],
        'lastDurationSec': value['lastDurationSec'],
        'lastError': value['lastError'],
        'lastFinishedAt': value['lastFinishedAt'],
        'lastRequests': value['lastRequests'],
        'lastSamples': value['lastSamples'],
        'lastStartedAt': value['lastStartedAt'],
        'lastStatus': value['lastStatus'],
        'nextRunAt': value['nextRunAt'],
    };
}

